import { UntitledIcon } from '@faceup/icons'
import { ulLogOut01 } from '@faceup/icons/ulLogOut01'
import { defineMessages, FormattedMessage } from '@faceup/localization'
import { Button, type ButtonProps } from '@faceup/ui-base'
import { startTransition } from 'react'
import { useAppLock } from '../App/AppLockProvider'

const messages = defineMessages('followUp.components.logoutButton', [
  { id: 'logout', defaultMessage: 'Sign out' },
] as const)

type LogoutButtonProps = Pick<ButtonProps, 'size'>

export const LogoutButton = (props: LogoutButtonProps) => {
  const { logout } = useAppLock()

  return (
    <Button
      {...props}
      type='text'
      icon={<UntitledIcon icon={ulLogOut01} />}
      onClick={() => {
        startTransition(async () => {
          await logout()
          window.location.href = '/'
        })
      }}
    >
      <FormattedMessage message={messages.logout} />
    </Button>
  )
}
